"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const setup_1 = require("./setup");
const load_1 = require("./load");
const isfunc_1 = require("./isfunc");
const defaultGlobalDependencies = {};
const defaultGetDependencies = () => false;
const defaultCache = {
    retrieve() {
        return Promise.resolve([]);
    },
    update(_, received) {
        return Promise.resolve(received);
    },
};
function checkCreateApi(createApi) {
    if (!isfunc_1.isfunc(createApi)) {
        console.warn('Invalid `createApi` function. Skipping module installation.');
        return false;
    }
    return true;
}
function checkFetchModules(fetchModules) {
    if (!isfunc_1.isfunc(fetchModules)) {
        console.error('Could not get the modules. Provide a valid `getModules` function as prop.');
        return false;
    }
    return true;
}
/**
 * Loads the modules metadata and puts them in the cache, if provided.
 * @param fetchModules The function to resolve the modules.
 * @param cache The optional cache to use initially and update later.
 */
function loadModulesMetadata(fetchModules, cache = defaultCache) {
    if (checkFetchModules(fetchModules)) {
        return Promise.resolve(cache.retrieve()).then(cachedModules => Promise.resolve(fetchModules(cachedModules || [])).then(receivedModules => cache.update(cachedModules, receivedModules)));
    }
    return Promise.resolve([]);
}
exports.loadModulesMetadata = loadModulesMetadata;
function getDependencyResolver(globalDependencies = defaultGlobalDependencies, getLocalDependencies = defaultGetDependencies) {
    return target => {
        return getLocalDependencies(target) || globalDependencies;
    };
}
exports.getDependencyResolver = getDependencyResolver;
/**
 * Loads the modules by first getting them, then evaluating the raw content.
 * @param fetchModules The function to resolve the modules.
 * @param fetchDependency A function to fetch the dependencies. By default, `fetch` is used.
 * @param dependencies The availablly global dependencies, if any.
 * @returns A promise leading to the evaluated modules.
 */
function loadModules(fetchModules, fetchDependency, globalDependencies, getLocalDependencies, cache) {
    const getDependencies = getDependencyResolver(globalDependencies, getLocalDependencies);
    return loadModulesMetadata(fetchModules, cache).then(moduleData => Promise.all(moduleData.map(m => load_1.loadModule(m, getDependencies, fetchDependency))));
}
exports.loadModules = loadModules;
/**
 * Sets up the evaluated modules to become integrated modules.
 * @param createApi The function to create an API object for a module.
 * @param modules The available evaluated app modules.
 * @returns The integrated modules.
 */
function createModules(createApi, modules) {
    if (checkCreateApi(createApi)) {
        for (const app of modules) {
            const api = createApi(app);
            setup_1.setupModule(app, api);
        }
    }
    return modules;
}
exports.createModules = createModules;
/**
 * Sets up an evaluated module to become an integrated module.
 * @param createApi The function to create an API object for the module.
 * @param app The available evaluated app module.
 * @returns The integrated module.
 */
function createModule(createApi, app) {
    if (checkCreateApi(createApi)) {
        const api = createApi(app);
        setup_1.setupModule(app, api);
    }
    return app;
}
exports.createModule = createModule;
